"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SprintExpandOption = exports.SprintSortField = exports.SprintType = exports.SprintIntegrationType = exports.SprintState = void 0;
var SprintState;
(function (SprintState) {
    SprintState["Active"] = "ACTIVE";
    SprintState["Closed"] = "CLOSED";
    SprintState["Future"] = "FUTURE";
})(SprintState = exports.SprintState || (exports.SprintState = {}));
var SprintIntegrationType;
(function (SprintIntegrationType) {
    SprintIntegrationType["JIRA"] = "JIRA";
})(SprintIntegrationType = exports.SprintIntegrationType || (exports.SprintIntegrationType = {}));
var SprintType;
(function (SprintType) {
    SprintType["Sprint"] = "Sprint";
    SprintType["DevCycle"] = "DevCycle";
})(SprintType = exports.SprintType || (exports.SprintType = {}));
var SprintSortField;
(function (SprintSortField) {
    SprintSortField["StartDate"] = "start_date";
    SprintSortField["EndDate"] = "end_date";
    SprintSortField["CompleteDate"] = "complete_date";
})(SprintSortField = exports.SprintSortField || (exports.SprintSortField = {}));
var SprintExpandOption;
(function (SprintExpandOption) {
    SprintExpandOption["Board"] = "Board";
})(SprintExpandOption = exports.SprintExpandOption || (exports.SprintExpandOption = {}));
//# sourceMappingURL=sprint.js.map